import React from "react";
import { Field, IconButton, Input, InputGroup } from "@chakra-ui/react";
import { t } from "i18next";
import { CopyIcon } from "../../../shared/views/icons";
import { toast } from "../../../shared/views/CustomToaster";

const i18prefix = "account:Integrations.display";

export const DisplayKey: React.FC<{
  label: string;
  value: string;
}> = ({ value, label }) => {
  return (
    <Field.Root>
      <Field.Label>{label}</Field.Label>
      <InputGroup
        endElement={
          <IconButton
            size="sm"
            colorPalette="primary"
            variant="ghost"
            aria-label={t(`${i18prefix}.copy`)}
            onClick={() => {
              navigator.clipboard.writeText(value);
              toast("success", t(`${i18prefix}.toast.copied`));
            }}
          >
            <CopyIcon />
          </IconButton>
        }
      >
        <Input size={"sm"} readOnly value={value} fontFamily="monospace" />
      </InputGroup>
    </Field.Root>
  );
};
